import { PriceConfig } from '~/lib/atom/types/price-config';

import { addToCart } from './events/add-to-cart';
import { pageView } from './events/page-view';
import { removeFromCart } from './events/remove-from-cart';
import { viewCart } from './events/view-cart';
import { viewItem } from './events/view-item';
import { log } from './log';

interface AnalyticsEvent {
  type: Gtag.EventNames;
  payload?: Gtag.EventParams;
}

interface AddToCartEvent extends AnalyticsEvent {
  type: 'add_to_cart';
  payload: {
    currency: string;
    value: number;
    items: Array<{ item_id: string; price: number; quantity: number } & Gtag.Item>;
  };
}

interface RemoveFromCartEvent extends AnalyticsEvent {
  type: 'remove_from_cart';
  payload: {
    currency: string;
    value: number;
    items: Array<{ item_id: string; price: number; quantity: number } & Gtag.Item>;
  };
}

interface PageViewEvent extends AnalyticsEvent {
  type: 'page_view';
}

interface ViewItemEvent extends AnalyticsEvent {
  type: 'view_item';
}

interface ViewCartEvent extends AnalyticsEvent {
  type: 'view_cart';
}

// TODO: I don't like having to add each event here... we not just use the type from gtag?
export const event = (
  e: AddToCartEvent | PageViewEvent | ViewItemEvent | ViewCartEvent | RemoveFromCartEvent,
) => {
  log(`pushing event to gtag (${e.type})`, e);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.gtag) {
    window.gtag('event', e.type, e.payload);
  }
};

const set = (...args: Gtag.GtagCommands['set']) => {
  log(`pushing set to gtag ${JSON.stringify(args)}`, args);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.gtag) {
    window.gtag('set', ...args);
  }
};

export const getAnalyticsInstance = ({ priceConfig }: { priceConfig: PriceConfig }) => ({
  viewCart: viewCart(priceConfig),
  viewItem: viewItem(priceConfig),
  pageView: pageView(),
  addToCart: addToCart(priceConfig),
  removeFromCart: removeFromCart(priceConfig),
  event,
  set,
});

export type Analytics = ReturnType<typeof getAnalyticsInstance>;
